import React from "react";
import './SecondSector.css';

const SecondSector = () => {
  return (
    <section className="cajas">
      <div className="cajas-container">
        <div className="caja">
          <h2>+200</h2>
          <p>CLIENTES FELICES</p>
        </div>
        <div className="caja">
          <h2>+10k</h2>
          <p>SERVICIOS APLICADOS</p>
        </div>
        <div className="caja">
          <h2>+16</h2>
          <p>AÑOS DE EXPERIENCIA</p>
        </div>
      </div>
      <div className="titulo-inv">
        <h1>Crecer invirtiendo en Dubai</h1>
        <p>MÁS QUE UNA INVERSIÓN, ES UNA INVITACIÓN A UNIRTE A UN MERCADO INMOBILIARIO EN CONTINUO DESARROLLO Y EXPANSIÓN.</p>
      </div>
    </section>
  );
};

export default SecondSector;